export const MenuIconsId = {
  Home: 0,
  PayTable: 1,
  GameHistory: 2,
  GameRules: 3,
};
